import React from 'react';
import style from './style.scss'
const H1 = (props)=>{
    return (<h1>{props.children}</h1>)
}
const Header = (props) => {
    const {field} = props;
    const Type = field.subtype
    return (
        <div>
            <Type
                className={style.formHeader}
            >
                {field.label}
            </Type>

        </div>
    )
}

export default Header;
